import type {MaybeRef} from 'vue';

export function subDomainKey(subdomain: MaybeRef<string | null>) {
    return ['subdomain', subdomain];
}

export function authorizationSettingsKey(subdomain: MaybeRef<string | null>) {
    return [...subDomainKey(subdomain), 'authorizationSettings'];
}

export function whitelabelSettingsKey(subdomain: MaybeRef<string | null>) {
    return [...subDomainKey(subdomain), 'whitelabelSettings'];
}
